import * as z from "zod/v4";

export const putEcwidIntegration = {
  name: "putEcwidIntegration" as const,
  input: z.object({
    enabled: z.boolean(),
    storeId: z.string().min(1),
    accessToken: z.string().optional(),
    customerGroup: z.string().min(1),
    clientId: z.string().optional(),
    clientSecret: z.string().optional(),
    createForReturns: z.boolean(),
    createForClaims: z.boolean(),
    createForWarranties: z.boolean(),
    filterByReturnReason: z.boolean(),
    allowedReturnReasons: z.array(z.string()),
    overrideSkus: z.boolean(),
    skuOverride: z.string(),
  }),
  output: z.object({}),
};
